import React from "react";
import { Select, SelectProps } from "@mui/material";

// interface selectProps extends SelectProps { }

const CustomSelect = (props) => {
    const { children, ...rest } = props;
    return (
        <Select
            MenuProps={{
                PaperProps: {
                    sx: {
                        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                        borderRadius: "7px",
                        marginTop: "5px",

                        "& .MuiMenuItem-root": {
                            padding: 0,
                            fontSize: "11px",
                            fontWeight: "500",
                            color: "#525050",
                            lineHeight: "1",

                            "&:hover": {
                                backgroundColor: "#ffffff",
                                color: "#111ae9"
                            },

                            "&:not(:last-child)": {
                                marginBottom: "10px"
                            },

                            "&:first-child": {
                                display: 'none'
                            },

                            "& .MuiTouchRipple-root": {
                                display: 'none'
                            }
                        },
                        "& .Mui-selected": {
                            background: "#fff !important"
                        },

                        "& .MuiList-root": {
                            padding: "20px 14px",
                            minWidth: "134px"
                        }
                    }
                }
            }}
            {...rest}
        >
            {children}
        </Select>
    );
};

export default CustomSelect;
